import { createSlice } from "@reduxjs/toolkit";

const AnalyticsSlice = createSlice({
  name: "Analytics",
  initialState: {
    getTopsellingProductLoading: false,
    getTopsellingProductdata: [],
    getTopsellingProductError: false,
  },
  reducers: {
    getTopsellingProductRequest: (state) => {
      state.getTopsellingProductLoading = true;
    },
    getTopsellingProductSuccess: (state, action) => {
      state.getTopsellingProductLoading = false;
      state.getTopsellingProductdata = action.payload;
    },
    getTopsellingProductFailure: (state, action) => {
      state.getTopsellingProductLoading = false;
      state.getTopsellingProductError = action.payload;
    },
  },
});

export const {
  getTopsellingProductRequest,
  getTopsellingProductSuccess,
  getTopsellingProductFailure,
} = AnalyticsSlice.actions;

export default AnalyticsSlice.reducer;
